module.exports = __webpack_public_path__ + "static/media/masph.dcb3010a.pdf";